import * as cheerio from "cheerio";
import { isNil } from "lodash";

/** Quill returns unordered lists as ordered list with a data-list property which can't be used by other tools.
 * Therefore we replace ol + bullet list with ul.
 */
export function transformOlToUl(html: string): string {
  if (isNil(html)) return null;

  const $ = cheerio.load(html);

  $("ol").each((_, ol) => {
    const $ol = $(ol);
    const hasBulletListItem = $ol.find("li[data-list='bullet']").length > 0;

    if (hasBulletListItem) {
      const $ul = $("<ul></ul>").html($ol.html());
      $ol.replaceWith($ul);
    }
  });
  return $("body")?.html();
}
